<script setup lang="ts">
import { computed } from 'vue'

import { useThemeStore } from '@/stores/theme'

const theme = useThemeStore()
const label = computed(() => ({ system: '跟随系统', light: '浅色', dark: '深色' })[theme.mode])
</script>

<template>
  <button class="icon-button" type="button" :title="`主题：${label}`" :aria-label="`切换主题，当前${label}`" @click="theme.cycle">
    <span aria-hidden="true">◐</span>
  </button>
</template>
